<template>
    <div class="home_page">
        <div class="home_carousel">
          <el-carousel :interval="5000" arrow="always">
            <el-carousel-item>
              <span class="carouselItem01"></span>
              <!--<img src="../assets/images/carousel01.png" alt="">-->
            </el-carousel-item>
            <el-carousel-item>
              <span class="carouselItem02"></span>
              <!--<img src="../assets/images/carousel02.png" alt="">-->
            </el-carousel-item>
             <el-carousel-item>
              <span class="carouselItem03"></span>
              <!--<img src="../assets/images/carousel02.png" alt="">-->
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="company_introduce">
            <div>
              <div class="introduce_left">
                <h3>公司介绍</h3>
                <p>深圳市博商探寻企业咨询有限公司，专注于助力企业全要素销售能力，是打造卓越绩效销售团队的云服务商，其秉承「销售赋能，益企营」的理念，为企业提供高质量全流程业务场景闭环管理软件产品和信息化服务的专业公司。包括引流工具(直播 活动分享 众筹)、管理咨询(商学院) 与企业全景运营框架销售工具（益企营平台）。</p>
              </div>
              <div class="introduce_right">
                <h3>联系我们</h3>
                <ul>
                  <li><span>服务热线：</span>0755-86681611</li>
                  <li><span>客服经理：</span>18948329683</li>
                  <li><span>企业地址：</span>深圳市前海深港合作区妈湾十九单元03街坊信利康大厦17F</li>
                </ul>
              </div>
            </div>
        </div>
      <div class="home_part3">
        <div>
          <h1 class="introduce_title"><span>益企营赋能<b></b></span></h1>
          <el-row class="comprehensive_list">
            <el-col :span="8" class="comprehensive_item">
              <ul>
                <li class="comprehensive_image"><img src="../assets/images/comprehensive01.png" alt=""></li>
                <li class="comprehensive_title">经营管控智能化系统</li>
                <li class="comprehensive_introduce">经营管控-- 点、线、面全景运营的视角，实现企业的三个支柱：战略、团队、平台。</li>
              </ul>
            </el-col>
            <el-col :span="8" class="comprehensive_item">
              <ul>
                <li class="comprehensive_image"><img src="../assets/images/comprehensive02.png" alt=""></li>
                <li class="comprehensive_title">智能CRM管理系统</li>
                <li class="comprehensive_introduce">完美融合先进的管理流程及管理思想、将CRM管理实现到最符合行业标准。</li>
              </ul>
            </el-col>
            <el-col :span="8" class="comprehensive_item">
              <ul>
                <li class="comprehensive_image"><img src="../assets/images/comprehensive03.png" alt=""></li>
                <li class="comprehensive_title">目标考核管理系统</li>
                <li class="comprehensive_introduce">从客户管理出发，实现经营业绩、拜访等各项指标录入进行考核权重输出评分。</li>
              </ul>
            </el-col>
          </el-row>
          <el-row class="comprehensive_list">
            <el-col :span="8" class="comprehensive_item">
              <ul>
                <li class="comprehensive_image"><img src="../assets/images/comprehensive04.png" alt=""></li>
                <li class="comprehensive_title">项目计划管理系统</li>
                <li class="comprehensive_introduce">完美结合年度经营计划进行的项目管理指标，按项目分解每步计划进行管理跟进，实现项目制管理！</li>
              </ul>
            </el-col>
            <el-col :span="8" class="comprehensive_item">
              <ul>
                <li class="comprehensive_image"><img src="../assets/images/comprehensive05.png" alt=""></li>
                <li class="comprehensive_title">微众筹活动管理系统</li>
                <li class="comprehensive_introduce">微众筹活动基于拼课、一人支付对应费用减少而设计，适用于共同众筹同一个活动或课程。</li>
              </ul>
            </el-col>
            <el-col :span="8" class="comprehensive_item">
              <ul>
                <li class="comprehensive_image"><img src="../assets/images/comprehensive06.png" alt=""></li>
                <li class="comprehensive_title">线上办公审核OA管理系统</li>
                <li class="comprehensive_introduce">线上办公管理，申请各项表单、流程自由可配定制化流程。随时随地移动化办公审批。</li>
              </ul>
            </el-col>
          </el-row>
          <el-row class="comprehensive_list">
            <el-col :span="8" class="comprehensive_item">
              <ul>
                <li class="comprehensive_image"><img src="../assets/images/comprehensive05.png" alt=""></li>
                <li class="comprehensive_title">财务预算报销管理系统</li>
                <li class="comprehensive_introduce">财务部门、项目预算等各项预算录入，后财务报销年度、月度预算额度可控。线上申请、审核等一目了然。</li>
              </ul>
            </el-col>
            <el-col :span="8" class="comprehensive_item">
              <ul>
                <li class="comprehensive_image"><img src="../assets/images/comprehensive06.png" alt=""></li>
                <li class="comprehensive_title">活动分销管理系统</li>
                <li class="comprehensive_introduce">单独的分销管理功能，利用每一场活动进行管理、线上报名、收费、签到一体化活动管理系统，还可以众筹形式发起活动。</li>
              </ul>
            </el-col>
            <el-col :span="8" class="comprehensive_item"></el-col>
          </el-row>
        </div>
      </div>
      <div class="home_part4">
        <div>
          <h1 class="introduce_title"><span>益企营赋能<b></b></span></h1>
          <el-row class="business_list">
            <el-col :span="6" class="business_item">
              <div class="business_inner">
                <img src="../assets/images/business01.png" alt=""><br>
                <span>线索</span>
              </div>
            </el-col>
            <el-col :span="6" class="business_item">
              <div class="business_inner">
                <img src="../assets/images/business02.png" alt=""><br>
                <span>意向</span>
              </div>
            </el-col>
            <el-col :span="6" class="business_item">
              <div class="business_inner">
                <img src="../assets/images/business03.png" alt=""><br>
                <span>客户</span>
              </div>
            </el-col>
            <el-col :span="6" class="business_item">
              <div class="business_inner no_arrow">
                <img src="../assets/images/business04.png" alt=""><br>
                <span>订单/缴费</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span class="stance"></span>
              <img class="stance_image" src="../assets/images/arrow.png" alt="">
            </el-col>
            <el-col :span="8">
              <div class="business_inner business_second">
                <img src="../assets/images/business05.png" alt=""><br>
                <span>机会/预测</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="business_inner no_arrow business_last">
                <img src="../assets/images/business06.png" alt=""><br>
                <span class="business_inner_text">智能风险预警</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="home_part5">
        <div>
          <h1 class="introduce_title"><span>益企营是一个什么平台<b class="platform_line"></b></span></h1>
          <el-row>
            <el-col :span="8" class="platform_item">
              <div class="platform_inner">
                <img src="../assets/images/platform01.png" alt=""><br>
                <span>业务员说：</span>
                <dl class="platform_copy_writing">
                  <dt>智能CRM是高效业务助手</dt>
                  <dd>
                    <ul>
                      <li>有效获客、高效跟进、准确预测</li>
                      <li>帮我自动分析销售过程中的风险预警</li>
                      <li>并提供高效业绩解决方案</li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </el-col>
            <el-col :span="8" class="platform_item platform_item_center">
              <div class="platform_inner">
                <img src="../assets/images/platform02.png" alt=""><br>
                <span>销售经理说：</span>
                <dl class="platform_copy_writing">
                  <dt>智能CRM是高效团队管理工具</dt>
                  <dd>
                    <ul>
                      <li>有效进行部门目标业绩管理、商机覆盖率、</li>
                      <li>人均生产力、考核，预算</li>
                      <li>及时预测和风险预警协调协助提高业绩，</li>
                      <li>完美掌控计划实施全过程。</li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </el-col>
            <el-col :span="8" class="platform_item">
              <div class="platform_inner">
                <img src="../assets/images/platform03.png" alt=""><br>
                <span>老板说：</span>
                <dl class="platform_copy_writing">
                  <dt>智能CRM帮我实现全景高效业绩管理</dt>
                  <dd>
                    <ul>
                      <li>全景纵览全公司业绩情况</li>
                      <li>计划目标实施全过程</li>
                      <li>通过自动化纵深全景的数据分析</li>
                      <li>基于各维度数据表现定制更有效的策略</li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="home_part6">
       <div>
         <p>为了让您更熟悉我们的产品，我们提供了体验使用服务，</p>
         <p>在使用过程中有任何问题都欢迎您和我们沟通。</p>
         <button @click="showMainDialog=true">立即体验</button>
       </div>
      </div>
      <div class="home_part7">
        <div>
          <h1 class="introduce_title"><span>他们正在使用<b class="cooperation_line"></b></span></h1>
          <ul class="cooperation_list">
            <li><img src="../assets/images/cooperation01.png" alt=""></li>
            <li><img src="../assets/images/cooperation02.png" alt=""></li>
            <li><img src="../assets/images/cooperation03.png" alt=""></li>
            <li><img src="../assets/images/cooperation04.png" alt=""></li>
          </ul>
          <ul class="cooperation_list">
            <li><img src="../assets/images/cooperation05.png" alt=""></li>
            <li class="cooperation_no_logo"><span>琅琨精品</span></li>
            <li class="cooperation_no_logo"><span>博商睿途</span></li>
            <li class="cooperation_no_logo"><span>承旭技术</span></li>
          </ul>
          <ul class="cooperation_list">
            <li class="cooperation_no_logo"><span>威尔健科技</span></li>
            <li class="cooperation_no_logo"><span>湖南卓誉科技</span></li>
            <li class="cooperation_no_logo"><span>顺高机电</span></li>
          </ul>
        </div>
      </div>
      <div class="home_part8">
        <div>
          <ul class="bosum_link">
            <li><b>友情链接：</b></li>
            <li><a target="_blank" href="http://live.bosum.com.cn/pc/#/index">博商在线学习</a></li>
            <li><a target="_blank" href="http://www.bosum.com/">博商管理科学研究院品牌官网</a></li>
            <li><a target="_blank" href="http://www.boshang.org/#/">博商同学会</a></li>
            <li><a target="_blank" href="http://www.bosum.com.cn/">博商报读官网</a></li>
          </ul>
        </div>
      </div>
      <my-dialog :show-dialog.sync="showMainDialog"></my-dialog>
    </div>
</template>

<script>
  import $ from 'jquery'
  import myDialog from '../components/my-dialog'
  export default {
      name: '',
      data:function(){
        return {
          showMainDialog:false,
          animateDH:'',
        }
      },
      mounted:function(){
        var vm = this;
        // $('body,html').animate({scrollTop: 0}, 300);
        vm.animateDH = $(".animation, .animation1");
        window.addEventListener('scroll', this.animationFnc);
       /*  $(window).bind('scroll', function () {
           console.log('hello');
            vm.animationFnc();
          });*/
      },
      methods:{
        animationFnc: function () {
          var vm = this;
          var pmh = window.innerHeight;
          var scrollTop = $(window).scrollTop() + pmh;
          if (vm.animateDH.length > 0) {
            vm.animateDH.each(function (i) {
              var animateTop = $(this).offset().top - pmh * 0.05;
              if (scrollTop > animateTop) {
                $(this).addClass("srcospcur");
              }
            });
          }
        },
      },
      components:{myDialog}
  }
</script>



// WEBPACK FOOTER //
// src/components/main.vue